import { call, put } from 'redux-saga/effects';
import { callWithAuth } from '../../sagaApiHelper';
import { generateTemplateApi } from '../../../api/apiLists/generateTemplateApi';
import { showAlert } from '../../alertSlice';
import { generateAIStart, generateAISuccess, generateAIFailure } from '../../whatsappSlice';
import { getOrFetchWabaId } from './utils';

export function* handleGenerateAITemplate(action) {
  try {
    yield put(generateAIStart());

    const { purpose, language = 'en', category = 'UTILITY' } = action.payload || {};

    if (!purpose || !purpose.trim()) {
      yield put(generateAIFailure('Please describe your template purpose'));
      return;
    }

    const wabaId = yield* getOrFetchWabaId();
    if (!wabaId) {
      yield put(generateAIFailure('WhatsApp Business Account not found. Please connect with Meta first.'));
      yield put(showAlert({ message: 'WhatsApp Business Account not found. Please connect with Meta first.', type: 'error' }));
      return;
    }

    const reqBody = {
      operation: 'GENERATE_TEMPLATE_WITH_AI',
      payload: {
        wabaId,
        language,
        category: category.toUpperCase(),
        purpose: purpose.trim(),
      },
    };

    const res = yield call(callWithAuth, generateTemplateApi, reqBody);

    if (res?.status === true) {
      yield put(generateAISuccess(res.data));
      yield put(showAlert({ message: 'Template generated successfully! Please review and edit if needed.', type: 'success' }));
    } else {
      const errMsg = res?.errMsg || 'Failed to generate template. Please try again.';
      yield put(generateAIFailure(errMsg));
      yield put(showAlert({ message: errMsg, type: 'error' }));
    }
  } catch (error) {
    yield put(generateAIFailure('An unexpected error occurred'));
    yield put(showAlert({ message: 'Error occurred while generating template', type: 'error' }));
  }
}
